<template>
  <div id="app">
    <router-view />
    <FooterSection/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  components: {
    FooterSection
  }
});
</script>
